module.exports = __webpack_public_path__ + "img/TXMeeting.007acf78.png";